<script setup lang="ts">
const { t } = useI18n()
const collectionsStore = useCollectionsStore()
const images = import.meta.glob('~/assets/homepage/*', { eager: true, import: 'default' })
</script>

<template>
  <div class="mx-auto max-w-3xl px-4 lg:max-w-[88rem] md:max-w-4xl lg:px-6 sm:px-4 sm:px-6">
    <div class="grid grid-cols-2 gap-2 py4 lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 lg:gap-2 lg:py8">
      <div
        class="relative col-span-2 h-35 items-center overflow-hidden rd-md lg:col-span-2 sm:col-span-2 lg:h-64"
        :class="[
          collectionsStore.rootCollections.status === 'pending' ? 'n-skeleton' : 'bg-gray-100',
        ]"
      >
        <NuxtLinkLocale to="/collections/11200">
          <div v-if="collectionsStore.rootCollections.status !== 'pending'" class="h-full w-full flex items-center px5 lg:px10">
            <h2 class="z2 bg-gray-100 bg-op-80 p1 text-2xl fw300">
              {{ t('homepage.trending_categories.women_fashion') }}
            </h2>
            <NuxtImg
              :src="images['/assets/homepage/women.png'] as string"
              decoding="async"
              importance="high"
              fetchpriority="high"
              loading="eager"
              width="280"
              height="280"
              alt="Women fashion"
              class="aspect-ratio -right-0 absolute w-50 -bottom-13 -right-5 lg:w-70 lg:-right-2 lg:-top-5"
              preload
            />
          </div>
        </NuxtLinkLocale>
      </div>
      <div
        class="relative col-span-1 h-35 items-center overflow-hidden rd-md lg:col-span-2 sm:col-span-2 lg:h-64"
        :class="[
          collectionsStore.rootCollections.status === 'pending' ? 'n-skeleton' : 'bg-gray-100',
        ]"
      >
        <NuxtLinkLocale to="/collections/10255">
          <div v-if="collectionsStore.rootCollections.status !== 'pending'" class="h-full w-full flex items-center px5 md:px10">
            <h2 class="z2 rd-md bg-gray-100 bg-op-80 p1 text-2xl fw300">
              {{ t('homepage.trending_categories.toys') }}
            </h2>
            <NuxtImg
              :src="images['/assets/homepage/toy.png'] as string"
              decoding="async"
              importance="high"
              fetchpriority="high"
              loading="eager"
              width="280"
              height="280"
              alt="Toy"
              class="aspect-ratio absolute w-50 -bottom-8 -right-8 lg:top-5 lg:w-70 lg:-right-13"
              preload
            />
          </div>
        </NuxtLinkLocale>
      </div>
      <div
        class="relative col-span-1 h-35 items-center overflow-hidden rd-md lg:col-span-1 sm:col-span-1 lg:h-64"
        :class="[
          collectionsStore.rootCollections.status === 'pending' ? 'n-skeleton' : 'bg-gray-100',
        ]"
      >
        <NuxtLinkLocale to="/collections/9534">
          <div v-if="collectionsStore.rootCollections.status !== 'pending'" class="h-full w-full flex items-center px5 md:px10">
            <h2 class="z2 rd-md bg-gray-100 bg-op-80 p1 text-2xl fw300">
              {{ t('homepage.trending_categories.home_decor') }}
            </h2>
            <NuxtImg
              :src="images['/assets/homepage/home_and_garden.png'] as string"
              decoding="async"
              loading="lazy"
              width="280"
              height="280"
              alt="Home"
              class="aspect-ratio absolute bottom-0 right-1 w-50 lg:right-0 lg:w-70 lg:-right-9 lg:-top-5"
            />
          </div>
        </NuxtLinkLocale>
      </div>
      <div
        class="relative col-span-1 h-35 items-center overflow-hidden rd-md lg:col-span-1 sm:col-span-1 lg:h-64"
        :class="[
          collectionsStore.rootCollections.status === 'pending' ? 'n-skeleton' : 'bg-gray-100',
        ]"
      >
        <NuxtLinkLocale to="/collections/10905">
          <div v-if="collectionsStore.rootCollections.status !== 'pending'" class="h-full w-full flex items-center px5 md:px10">
            <h2 class="z2 rd-md bg-gray-100 bg-op-80 p1 text-2xl fw300">
              {{ t('homepage.trending_categories.mans') }}
            </h2>
            <NuxtImg
              :src="images['/assets/homepage/man.png'] as string"
              decoding="async"
              loading="lazy"
              width="280"
              height="280"
              alt="Man"
              class="aspect-ratio absolute right-0 w-70 -bottom-1 -right-10"
            />
          </div>
        </NuxtLinkLocale>
      </div>
      <div
        class="relative col-span-1 h-35 items-center overflow-hidden rd-md lg:col-span-2 sm:col-span-2 lg:h-64"
        :class="[
          collectionsStore.rootCollections.status === 'pending' ? 'n-skeleton' : 'bg-gray-100',
        ]"
      >
        <NuxtLinkLocale to="/collections/10816">
          <div v-if="collectionsStore.rootCollections.status !== 'pending'" class="h-full w-full flex items-center px5 md:px10">
            <h2 class="z2 rd-md bg-gray-100 bg-op-80 p1 text-2xl fw300">
              {{ t('homepage.trending_categories.children_fashion') }}
            </h2>
            <NuxtImg
              :src="images['/assets/homepage/baby.png'] as string"
              decoding="async"
              loading="lazy"
              alt="Baby"
              class="aspect-ratio absolute bottom-2 right-0 w-50 lg:bottom-0 lg:right-0 lg:w-96 lg:-right-2"
              width="384"
              height="384"
            />
          </div>
        </NuxtLinkLocale>
      </div>
    </div>
  </div>
</template>
